// api/customers.js
import apiClient from './client';

export const customerApi = {
  // Get all customers
  getAll: () => apiClient.get('/customers'),
  
  // Get customer by ID
  getById: (id) => apiClient.get(`/customers/${id}`),
  
  // Create customer
  create: (data) => apiClient.post('/customers', data),
  
  // Update customer
  update: (id, data) => apiClient.put(`/customers/${id}`, data),
  
  // Delete customer
  delete: (id) => apiClient.delete(`/customers/${id}`),
  
  // Search customers
  search: (query) => apiClient.get(`/customers/search?q=${query}`),
};